import {SET_APPLICATION_FLAGS, SET_VERSION_MISMATCH_FLAG, CLEAR_VERSION_MISMATCH_FLAG} from "./dispatchTypes";
import {APP_VERSION} from "../config/env";

export const setApplicationFlags = (version) => dispatch => {
    const appVersion = getAppVersion();

    dispatch({
        type: SET_APPLICATION_FLAGS,
        payload:{
            appVersion: appVersion,
            webVersion: APP_VERSION,
            reduxStateVersion: evaluateReduxStateVersion(appVersion),
            versionMismatch: false,
            flags: {
                deviceStorage: evaluateDeviceStorageFlag(appVersion),
                // TODO: Remove this flag after 12/31/2025
                cacheReset: evaluateCacheResetFlag(appVersion)
            }
        }
    })

};

export const setVersionMismatchFlag = () => dispatch => {
    dispatch({
        type: SET_VERSION_MISMATCH_FLAG
    });
};

export const clearVersionMismatchFlag = () => dispatch => {
    dispatch({
        type: CLEAR_VERSION_MISMATCH_FLAG
    });
};

export const getAppVersion = () => {
    try {
        return window.NativeApp.getAppVersion();
    }
    catch {
        return "0.0"
    }
};

export const evaluateDeviceStorageFlag = (version) => {
    return parseInt(version.replace(/\./g,"")) > 10024
}

export const evaluateReduxStateVersion = (version) => {
    return parseInt(version.replace(/\./g,"")) < 10036 ? 1 : 2;
}

// TODO: Remove this function after 12/31/2025
export const evaluateCacheResetFlag = (version) => {
    const numericVersion = parseInt(version.replace(/\./g,""));
    if (numericVersion >= 20000) return numericVersion >= 20006;
    if (numericVersion >= 10000) return numericVersion >= 10064;

    return false;
}